import { render } from "./Percentage.vue?vue&type=template&id=28c1a6ad"
import script from "./Percentage.vue?vue&type=script&lang=js"
export * from "./Percentage.vue?vue&type=script&lang=js"

import "./Percentage.vue?vue&type=style&index=0&id=28c1a6ad&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__